<template>

    <trax-ui-ajax-table-with-crud-actions 
        :id="id" :titles="titles" :props="props" :bus="bus" :edit-url-map="editUrlMap" duplicate="1" 
        :endpoint="endpoint">
    </trax-ui-ajax-table-with-crud-actions>
    
</template>

<script>
    export default {
    
        props: {
            bus: null,
            id: null,
            endpoint: null
        },

        data: function() {
            return {
                titles: [
                    lang.polaris.form.name,
                    lang.polaris.form.description,
                    lang.polaris.form.status,
                    ''
                ],
                props: [
                    {source: 'name', class: 'font-weight-bold'},
                    {source: 'description', width: '50%', truncate: 150},
                    {source: this.status }
                ],
                status_select: data.status_select,
                editUrlMap: {
                    prop: 'type',
                    map: data.program_edit_routes
                }
            }
        },

        methods: {
        
            // Columns rendering

            status(data, type, row, meta) {
                var label = this.status_select.find(status => status.value == row.status).name
                var color = 'info';
                if (row.status == 'active') color = 'success';
                else if (row.status == 'maintenance') color = 'warning';
                else if (row.status == 'archived') color = 'default';
                return '<span class="badge badge-'+color+'">'+label+'</span>';
            }
        }

    }
</script>
